import React from 'react';
import PropTypes from 'prop-types';

import CenteredContainer from 'styled/Page/CenteredContainer';
import ErrorText from 'styled/Page/ErrorText';

export function MaterialNotFound(props) {
  return (
    <CenteredContainer>
      <svg width="75" height="84" viewBox="0 0 75 84" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.214 70.374l-1.696-.266H1.7A1.7 1.7 0 0 1 0 68.403V1.705C0 .765.764 0 1.7 0h46.676c.94 0 1.7.762 1.7 1.705v4.112l11.237 1.76a2.86 2.86 0 0 1 2.463 3.344l-.45 2.872 8.567 2.235a2.858 2.858 0 0 1 2.123 3.574L57.87 81.766a2.858 2.858 0 0 1-1.342 1.84c-.682.4-1.5.5-2.232.283L11.418 72.752a2.858 2.858 0 0 1-2.204-2.378zm1.885.297c.167.224.413.383.712.45l42.933 11.15a1.18 1.18 0 0 0 1.493-.9l16.16-62.22a1.18 1.18 0 0 0-.9-1.49l-8.435-2.2-9.258 58.937a2.858 2.858 0 0 1-3.346 2.463L11.1 70.67zM50.075 7.517v60.887c0 .94-.763 1.705-1.7 1.705h-30.05l32.42 5.098a1.18 1.18 0 0 0 1.397-1.042l9.98-63.53a1.18 1.18 0 0 0-1.043-1.396L50.076 7.516zM1.68 68.403c0 .017 46.697.026 46.697.026.01 0 .022-66.725.022-66.725 0-.017-46.7-.026-46.7-.026-.008 0-.02 66.723-.02 66.723zm9.005-19.736h28.708v-28.7h-28.71v28.7zm-1.68-29.062c0-.728.587-1.317 1.317-1.317h29.433c.727 0 1.316.586 1.316 1.317V49.03c0 .727-.585 1.316-1.315 1.316H10.322a1.314 1.314 0 0 1-1.317-1.316V19.605zm22.7 6.86L17.186 40.96l1.186 1.188L32.89 27.654l-1.186-1.188zM32.89 40.96L18.373 26.466l-1.186 1.188 14.517 14.494 1.186-1.188z" fill="currentColor" />
      </svg>

      <ErrorText>{props.text}</ErrorText>
    </CenteredContainer>
  );
}

MaterialNotFound.propTypes = {
  text: PropTypes.string,
};

MaterialNotFound.defaultProps = {
  text: 'Материалов не найдено',
};

export default MaterialNotFound;
